import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { AnonymousLayout } from "@/layouts/AnonymousLayout/AnonymousLayout";
import { anonymousRouting } from "@/modules/router/routings/anonymousRouting";
import { Button } from "@/modules/theme/components/Button/Button";
import { PageMeta } from "@/modules/theme/components/PageMeta";

import { Base404NotFoundLayout } from "./Base404NotFoundLayout";

const translationNamespace = "pages/AnonymousNotFoundPage";

export function AnonymousNotFoundPage() {
  const { t } = useTranslation(translationNamespace);
  const history = useHistory();
  return (
    <AnonymousLayout>
      <PageMeta title={t("Not Found")} />
      <Base404NotFoundLayout>
        <Button
          onClick={() => history.push(anonymousRouting.buildUrl("signIn"))}
        >
          {t("Back to Log in")}
        </Button>
      </Base404NotFoundLayout>
    </AnonymousLayout>
  );
}
